import type { ContentSection } from './types';

export const nextStepsContent: ContentSection = {
  id: 'next-steps',
  title: 'Next Steps 📞',
  content: 'Ready to visualize the future of your codebase?',
  customComponent: 'next-steps-cta'
};
